import { ObjectHelper } from "../Helpers/ObjectHelper";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerLessThanPropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerLessThanProperties = {
    [name in keyof PropertyComparerLessThanPropertyValues]: Property<PropertyComparerLessThanPropertyValues[name]>
};

export interface IPropertyComparerLessThan extends IPropertyComparer, PropertyComparerLessThanProperties
{
}

export class PropertyComparerLessThan extends PropertyComparer<PropertyComparerLessThanPropertyValues> implements IPropertyComparerLessThan
{
    public static override classNamespace = NAMESPACE + "PropertyComparerLessThan";
    public static override className = "PropertyComparerLessThan";

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return ObjectHelper.compare(propertyValue, constantValue) < 0;
    }

    // #endregion
}

